"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var album_simplified_1 = __importDefault(require("../album/album-simplified"));

var track_simplified_1 = __importDefault(require("./track-simplified"));

var Track = function (_super) {
  __extends(Track, _super);

  function Track(json) {
    var _this = _super.call(this, json) || this;

    _this.album = new album_simplified_1.default(json.album);
    _this.externalIds = json.external_ids;
    _this.popularity = json.popularity;
    return _this;
  }

  Object.defineProperty(Track.prototype, "albumName", {
    get: function get() {
      return this.album.name;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Track.prototype, "mainArtists", {
    get: function get() {
      return lodash_1.default.intersectionBy(this.artists, this.album.artists, 'id');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Track.prototype, "featuredArtists", {
    get: function get() {
      return lodash_1.default.differenceBy(this.artists, this.album.artists, 'id');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Track.prototype, "releaseYear", {
    get: function get() {
      return this.album.releaseYear;
    },
    enumerable: true,
    configurable: true
  });
  return Track;
}(track_simplified_1.default);

exports.default = Track;